/* NCMPRBL — Axis Collection : motion layer
   Signature moment : pinned frame-swap (pattern 10)
   Supporting       : split-text mask reveals, clip reveals, hero parallax,
                      dual photo drift band, odometer counters
   All motion is transform/opacity only and respects prefers-reduced-motion. */

(function () {
  'use strict';

  /* ---- section lifecycle plumbing (added 2026-08-12) ---------------------
     Shopify's theme editor destroys and re-renders a section's DOM on every
     edit without reloading the page, and it never re-runs a deferred script.
     Without this, one edit left the page inert and leaked a window listener
     per edit. init() holds all state, destroy() releases it, and GEN
     invalidates any rAF callback still queued from a previous generation. */
  var CLEANUP = [], GEN = 0;
  function on(target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    CLEANUP.push(function () { target.removeEventListener(type, fn, opts); });
  }
  function tracked(observer) {
    CLEANUP.push(function () { observer.disconnect(); });
    return observer;
  }
  function destroy() {
    GEN++;
    for (var i = 0; i < CLEANUP.length; i++) { try { CLEANUP[i](); } catch (e) {} }
    CLEANUP.length = 0;
  }

  function init() {
    var MY_GEN = ++GEN;
    function alive() { return MY_GEN === GEN; }

    /* ---------- live pricing (injected) ----------------------------------------
       Prices come from the #lp-prices JSON block, which the Liquid section renders
       directly from the product records. This file holds no authoritative price;
       the strings in FRAMES are a fallback for when the block is absent. */
    var LP_PRICES = (function () {
      try { return JSON.parse(document.getElementById('lp-prices').textContent); }
      catch (e) { return {}; }
    })();
    function lpRec(url) {
      var m = /\/products\/([^\/?#]+)/.exec(url || '');
      return (m && LP_PRICES[m[1]]) || null;
    }
    function lpPrice(url, fallback) {
      var r = lpRec(url);
      if (!r || !r.money) return fallback || '';
      return /USD/.test(fallback || '') ? r.money + ' USD' : r.money;
    }

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


    /* ---------- entrance reveals (scroll-driven, no IO race with image load) --- */
    var revealEls = [].slice.call(document.querySelectorAll('.rv, .clip, .lines'));
    function runReveals() {
      var vh = window.innerHeight;
      for (var i = revealEls.length - 1; i >= 0; i--) {
        var el = revealEls[i];
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) { el.classList.add('in'); revealEls.splice(i, 1); }
      }
    }

    /* ---------- odometer counters ---------- */
    var cio = tracked(new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target, target = parseFloat(el.dataset.count), isInt = el.dataset.int === '1';
        if (reduce) { el.textContent = isInt ? target : target.toFixed(2); return; }
        var t0 = null, dur = 1400;
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur), e2 = 1 - Math.pow(1 - p, 3), v = target * e2;
          el.textContent = isInt ? Math.round(v).toLocaleString() : v.toFixed(2);
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 }));
    document.querySelectorAll('[data-count]').forEach(function (el) { cio.observe(el); });

    /* ---------- scrub-fill manifesto sentence ---------- */
    var scrub = document.querySelector('[data-scrub]');
    var scrubWords = [];
    if (scrub) {
      var words = scrub.textContent.trim().split(/\s+/);
      scrub.textContent = '';
      words.forEach(function (w, i) {
        var b = document.createElement('b');
        b.textContent = w;
        scrub.appendChild(b);
        if (i < words.length - 1) scrub.appendChild(document.createTextNode(' '));
        scrubWords.push(b);
      });
    }

    /* ---------- pinned frame swap ---------- */
    var FRAMES = [
      { idx: 'Axis 01', name: 'Onyx Flat Top — Obsidian Black', desc: 'A distinctive flat top edge in thick acetate — premium sophistication with cultural inspiration.', price: '$435 USD', img: 'https://cdn.shopify.com/s/files/1/0278/2707/7225/files/onyxflattopfrontzoom1080.jpg?width=1400', url: 'https://ncmprblife.com/products/onyx-flat-top-eyeglasses-obsidian-black', bg: '#F2F2F2', fg: '#1A1A1A' },
      { idx: 'Axis 02', name: 'Espresso Flat Top — Espresso Marble', desc: 'Marbled acetate with depth that shifts in daylight. Structured enough to feel intentional.', price: '$475 USD', img: 'https://cdn.shopify.com/s/files/1/0278/2707/7225/files/AXIS02108034frame.jpg?width=1400', url: 'https://ncmprblife.com/products/axis-02-espresso', bg: '#EDE6DB', fg: '#1A1A1A' },
      { idx: 'Axis 03', name: 'Smoke Oak Flat Top — Champagne & Walnut', desc: 'Champagne translucency against walnut temples — the quietest frame in the collection.', price: '$495 USD', img: 'https://cdn.shopify.com/s/files/1/0278/2707/7225/files/smoke_oak_1080_main.jpg?width=1400', url: 'https://ncmprblife.com/products/axis-03-smoke-oak-flat-top-53mm-champagne-walnut-eyeglasses', bg: '#E1E9E6', fg: '#12352F' }
    ];
    var swapSec = document.getElementById('frames');
    var pin = document.getElementById('pin');
    var stages = [].slice.call(document.querySelectorAll('[data-stage]'));
    var sides = [].slice.call(document.querySelectorAll('[data-side]'));
    var dots = [].slice.call(document.querySelectorAll('[data-dot]'));
    var mIdx = document.querySelector('[data-m-idx]'), mName = document.querySelector('[data-m-name]'),
        mDesc = document.querySelector('[data-m-desc]'), mPrice = document.querySelector('[data-m-price]');
    var dockImg = document.getElementById('dockImg'), dockName = document.getElementById('dockName'),
        dockPrice = document.getElementById('dockPrice'), dockCta = document.getElementById('dockCta'),
        dock = document.getElementById('dock');
    var active = -1;

    function setFrame(i) {
      if (i === active) return;
      active = i;
      var f = FRAMES[i];
      stages.forEach(function (el, n) { el.classList.toggle('on', n === i); });
      sides.forEach(function (el) { el.classList.toggle('on', +el.dataset.side === i); });
      dots.forEach(function (el, n) { el.classList.toggle('on', n === i); });
      if (pin) { pin.style.backgroundColor = f.bg; pin.style.color = f.fg; }
      if (mIdx) { mIdx.textContent = f.idx; mName.textContent = f.name; mDesc.textContent = f.desc; mPrice.textContent = lpPrice(f.url, f.price); }
      if (dockImg) { dockImg.src = f.img; dockName.textContent = f.idx + ' — ' + f.name; dockPrice.textContent = lpPrice(f.url, f.price); dockCta.href = f.url; }
    }
    setFrame(0);

    dots.forEach(function (d) {
      on(d, 'click', function () {
        var i = +d.dataset.dot;
        var top = swapSec.offsetTop + (swapSec.offsetHeight - window.innerHeight) * ((i + 0.5) / FRAMES.length);
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    /* ---------- drift band + hero parallax + scrub fill + dock (single rAF) ---------- */
    var drifts = [].slice.call(document.querySelectorAll('[data-drift]'));
    var paras = [].slice.call(document.querySelectorAll('[data-para]'));
    var heroImg = document.getElementById('heroImg');
    var ticking = false;

    function frame() {
      if (!alive()) return;
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      var vh = window.innerHeight;

      runReveals();

      if (!reduce) {
        /* hero zoom / drift */
        if (heroImg && y < vh * 1.2) {
          var p = Math.min(1, y / vh);
          heroImg.style.transform = 'scale(' + (1.08 - p * 0.06) + ') translateY(' + (p * 56) + 'px)';
        }
        /* drift band rows */
        drifts.forEach(function (row) {
          var r = row.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) return;
          var prog = (vh - r.top) / (vh + r.height); /* 0 -> 1 */
          var dir = +row.dataset.drift;
          var span = row.scrollWidth / 2;
          var shift = (prog - 0.5) * span * 0.5 * dir;
          row.style.transform = 'translateX(' + (dir < 0 ? -span * 0.25 - shift : -span * 0.25 + shift) + 'px)';
        });
        /* small parallax pairs */
        paras.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) return;
          var prog = (vh - r.top) / (vh + r.height) - 0.5;
          el.style.transform = 'translateY(' + (prog * +el.dataset.para) + 'px)';
        });
        /* scrub word fill */
        if (scrubWords.length) {
          var sr = scrub.getBoundingClientRect();
          var sp = (vh * 0.86 - sr.top) / (sr.height + vh * 0.24);
          sp = Math.max(0, Math.min(1, sp));
          var lit = Math.round(sp * scrubWords.length);
          scrubWords.forEach(function (w, i) { w.classList.toggle('lit', i < lit); });
        }
      } else if (scrubWords.length) {
        scrubWords.forEach(function (w) { w.classList.add('lit'); });
      }

      /* pinned frame swap */
      if (swapSec) {
        var sr2 = swapSec.getBoundingClientRect();
        var total = swapSec.offsetHeight - vh;
        var prog2 = Math.max(0, Math.min(0.9999, -sr2.top / total));
        setFrame(Math.floor(prog2 * FRAMES.length));
      }

      /* sticky dock: show after the frames section, hide over the closing block */
      if (dock) {
        var col = document.getElementById('collection');
        var closeSec = document.querySelector('.close');
        var show = col && (y + vh) > col.offsetTop + 200 && (!closeSec || y + vh < closeSec.offsetTop + 120);
        dock.classList.toggle('on', !!show);
      }
    }

    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', onScroll, { passive: true });
    frame();

    /* ---------- FAQ: one open at a time ---------- */
    var dets = [].slice.call(document.querySelectorAll('.faq details'));
    dets.forEach(function (d) {
      on(d, 'toggle', function () {
        if (d.open) dets.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });

    /* ---------- magnetic CTAs (desktop) ---------- */
    if (!reduce && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      document.querySelectorAll('.btn').forEach(function (b) {
        on(b, 'pointermove', function (e) {
          var r = b.getBoundingClientRect();
          var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
          var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
          b.style.transform = 'translate(' + (dx * 8).toFixed(2) + 'px,' + (dy * 6).toFixed(2) + 'px)';
        });
        on(b, 'pointerleave', function () {
          b.style.transition = 'transform .5s cubic-bezier(.16,1,.3,1)';
          b.style.transform = '';
          setTimeout(function () { b.style.transition = ''; }, 520);
        });
      });
    }
  }

  function boot() {
    destroy();
    if (document.querySelector('.axis-lp')) init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (t && t.querySelector && (t.querySelector('.axis-lp') || t.matches && t.matches('.axis-lp'))) boot();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var t = e.target;
    if (t && t.querySelector && (t.querySelector('.axis-lp') || t.matches && t.matches('.axis-lp'))) destroy();
  });
})();
